import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SecurityProviderProps {
  children: React.ReactNode;
}

export const SecurityProvider: React.FC<SecurityProviderProps> = ({ children }) => {
  return (
    <>
      <Helmet>
        {/* Content Security Policy - Enhanced */}
        <meta 
          httpEquiv="Content-Security-Policy" 
          content="default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://supabase.co https://*.supabase.co https://challenges.cloudflare.com https://vercel.live; style-src 'self' 'unsafe-inline' https://challenges.cloudflare.com https://fonts.googleapis.com; img-src 'self' data: https: blob:; font-src 'self' https: data:; connect-src 'self' https://*.supabase.co wss://*.supabase.co https://challenges.cloudflare.com https://api.exchangerate-api.com https://*.sentry.io https://vercel.live wss://ws-us3.pusher.com; frame-src https://challenges.cloudflare.com https://vercel.live; object-src 'none'; base-uri 'self'; form-action 'self';" 
        />
        
        {/* XSS Protection */}
        <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
        
        {/* Prevent MIME type sniffing */}
        <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
        
        {/* Prevent clickjacking - Removed X-Frame-Options to allow Lovable iframe functionality */}
        
        {/* Referrer Policy */}
        <meta name="referrer" content="strict-origin-when-cross-origin" />
        
        {/* Permissions Policy */}
        <meta 
          httpEquiv="Permissions-Policy" 
          content="camera=(), microphone=(), geolocation=(), payment=(), usb=(), autoplay=()" 
        />
      </Helmet>
      {children}
    </>
  );
};